<template>
  <layout name="LayoutDefault">
    <!-- Page Content -->
    <div class="container">
      <div class="row slider">
        <div class="col-md-12">
          <div
            id="sliderCarousel"
            class="carousel slide bg-white home-banner"
            data-ride="carousel"
          >
            <ol class="carousel-indicators">
              <li
                data-target="#sliderCarousel"
                v-for="(item, index) in banner"
                v-bind:class="{ active: index === 0 }"
                :data-slide-to="`${index}`"
                v-bind:key="index"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div
                v-bind:key="index"
                v-for="(item, index) in banner"
                v-bind:class="{ 'carousel-item': true, active: index === 0 }"
              >
              <component :is="item.short_description ? 'a' : 'div'" :href="item.short_description ? `${item.short_description}` : null">
                  <vue-load-image>
                    <img
                      slot="image"
                      v-bind:src="`${IMAGEURL}${item.image}`"
                      alt="Image"
                      style="max-width: 100%"
                    />
                    <img
                      slot="preloader"
                      v-bind:src="`${baseUrl}/assets/img/loader.gif`"
                      title="Image Loading..."
                    />
                    <div slot="error">can't load image</div>
                  </vue-load-image>
                </component>
                <!-- </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Category Slider (Mobile & Tablet Only) -->
      <div class="category-slider-section d-lg-none mb-2">
        <div class="category-slider" ref="categorySlider">
          <a
            v-for="(category, index) in categories"
            :key="index"
            :href="`${baseUrl}category/${category.id}/newest`"
            class="category-badge"
          >
            <div class="category-icon">
              {{ category.category_name.substring(0, 1) }}
            </div>
            <span class="category-name">{{ category.category_name }}</span>
          </a>
        </div>
      </div>

      <!-- Page Features -->
      <div class="body-section">
        <div
          v-for="(section, skey) in sectionProducts"
          v-bind:key="skey"
          class="row mb-4"
        >
          <div class="col-lg-12">
            <div class="section-column">
              <div class="section-header d-flex justify-content-between">
                <h2>
                  {{ section.title }}
                </h2>
                <div>
                  <a
                    :href="`${baseUrl}section/${section.id}/${section.slug}`"
                    class="more-link float-right mt-2 position-relative"
                    ><img src="/assets/img/arrow-right.png"
                  /></a>
                </div>
              </div>

              <div class="section-items">
                <slick v-if="section.products.length" :key="skey" :options="slickOptions">
                  <div v-for="(item, k) in section.products" :key="k" class="px-3">
                    <ProductCard :item="item" />
                  </div>
                </slick>
              </div>

              <div v-if="!sectionLoading && sectionProducts.length < 1">
                Sorry but no product found.
              </div>
            </div>
          </div>
        </div>

        <div v-if="homeAd" class="row mb-5 home-footer-ad">
          <div
            v-for="(item, k) in homeAd"
            v-bind:key="k"
            class="col-12 col-sm-6 mt-3 mt-lg-0"
          >
            <a :href="`${item.short_description}`">
              <img
                v-bind:src="`${IMAGEURL}${item.image}`"
                alt=""
                class="w-100 rounded"
              />
            </a>
          </div>
        </div>
      </div>

      <!---------------------popup----------------->

      <!-- Modal -->
      <div
        class="modal fade modal-center"
        id="myModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content" style="border: 0px">
            <button
              class="close"
              data-dismiss="modal"
              style="position: absolute;right: 0;z-index: 4;border: 1px solid #aa4242;padding: 0px 8px;background: #aa4242;color: #fff;"
            >
              &times;
            </button>

            <div class="modal-body" style="padding: 0px">
              <img
                v-if="popup"
                v-bind:src="`${IMAGEURL}${popup.image}`"
                alt="Image"
                class="img-responsive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";
import ProductCard from './common/ProductCard.vue';
import Slick from 'vue-slick';

export default {
  name: `Home`,
  data() {
    return {
      sectionProducts: [],
      banner: [],
      popup: null,
      homeAd: null,
      sectionLoading: true,
      categories: [],
      slickOptions: {
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        infinite: true,
        dots: false,
        arrows: false,
        draggable: true,
        swipe: true,
        swipeToSlide: true,
        touchThreshold: 3,
        speed: 400,
        cssEase: 'ease-in-out',
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 4 } },
          { breakpoint: 768, settings: { slidesToShow: 3 } },
          { breakpoint: 576, settings: { slidesToShow: 2 } }
        ]
      },
    };
  },
  components: {
    Layout,
    ProductCard,
    Slick,
    "vue-load-image": VueLoadImage,
  },
  methods: {
    getCategories() {
      fetch(`${this.APIURL}category-resources`)
        .then((response) => response.json())
        .then((json) => {
          this.categories = json.data;
        })
        .catch((error) => {
          console.error('Error fetching categories:', error);
          this.categories = [];
        });
    },
    getHomeSections() {
      this.$http
        .get("home-sections")
        .then((response) => {
          this.sectionProducts = response.data;
          this.sectionLoading = false;
        })
        .catch((e) => {
          this.sectionProducts = [];
          this.sectionLoading = false;
        });
    },
    getBanner() {
      fetch(this.APIURL + "cms-resources/Banner-Slider")
        .then((response) => response.json())
        .then((json) => (this.banner = json.data))
        .catch(function (error) {
          console.log(error);
        });
    },
    getPopUp() {
      this.$http
        .get("cms-resources/Pop-Up")
        .then((response) => {
          this.popup = response.data.data[0];
          //console.log(this.popup);
          if (this.popup.status == "Active") {
            $("#myModal").modal("show");
          }
        })
        .catch((e) => {
          this.popup = null;
        });
    },
    getAd() {
      this.$http
        .get("cms-resources/Home-Ad")
        .then((response) => {
          this.homeAd = response.data.data;
          //console.log(response);
        })
        .catch((e) => {
          this.homeAd = null;
        });
    },
  },
  mounted() {
    this.getPopUp();
    this.getHomeSections();
    this.getBanner();
    this.getAd();
    this.getCategories();
  },
};
</script>

<style scoped>
/* Category Slider Styles */
.category-slider-section {
  padding: 0;
}

.category-slider {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  padding: 15px 10px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.category-slider::-webkit-scrollbar {
  display: none;
}

/* Category Badge */
.category-badge {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  min-width: auto;
  max-width: none;
  padding: 8px 12px;
  background: #ffffff;
  border-radius: 8px;
  text-decoration: none;
  color: #333;
  transition: all 0.2s ease;
  border: 1px solid #aa4242;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.06);
}

.category-badge:hover {
  text-decoration: none;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12);
  transform: translateY(-2px);
  border-color: #d0d0d0;
}

/* Category Icon */
.category-icon {
  width: 28px;
  height: 28px;
  border-radius: 5px;
  background: #aa4242;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  flex-shrink: 0;
}

/* Category Name */
.category-name {
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  line-height: 1.2;
  color: #333;
  white-space: nowrap;
}

.category-badge:hover .category-name {
  color: #1976d2;
}

/* Mobile Styles */
@media screen and (max-width: 767px) {
  .category-badge {
    padding: 6px 10px;
    gap: 8px;
  }
  
  .category-icon {
    width: 26px;
    height: 26px;
    font-size: 12px;
  }
  
  .category-name {
    font-size: 12px;
  }
  
  .category-slider {
    gap: 10px;
    padding: 10px 8px;
  }
}

/* Tablet Styles */
@media screen and (min-width: 768px) and (max-width: 991px) {
  .category-badge {
    padding: 8px 14px;
    gap: 12px;
  }
  
  .category-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
  
  .category-name {
    font-size: 14px;
  }
}
</style>
